import {combineReducers} from 'redux';
import {connectRouter} from 'connected-react-router';

import locales from './locales';
import nextStep from './nextStep';
import regType from './regType';
import stepPayload from './stepPayload';
import globalErrorMessage from './globalErrorMessage';
import user from './user';
import prevCompletedStepSign from './prevCompletedStepSign';
import specificStep from "./specificStep";

const createRootReducer = history =>
  combineReducers({
    router: connectRouter(history),
    locales,
    nextStep,
    regType,
    stepPayload,
    globalErrorMessage,
    user,
    prevCompletedStepSign,
    specificStep,
  });

export default createRootReducer;
